/* import __COLOCATED_TEMPLATE__ from './android.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();